<template>
    <div class="gray-back" style="padding:.2rem 0 1rem 0">
        <van-form
                @submit="onSubmit" 
                @failed="onFailed" 
        >
            <van-cell-group>

                <van-cell title="图片证明"  >
                </van-cell>
                <div class="row">
                    <FileUploader uploadText="图片证明" :fileList="formData.yanshou_pic" :limit="1" accept=".zip,.rar"
                                  :name="'yanshou_pic'"></FileUploader>
                </div>
                <div class="operate-desc-left">建议打包上传一个压缩包文件</div>

                <van-cell title="验收表扫描件"  >
                </van-cell>

                <div class="row">
                    <PicUploader :fileList="formData.yanshoubiao_pic" :limit="5"
                                 :name="'yanshoubiao_pic'"></PicUploader>
                </div>
                <div class="operate-desc-left" @click="download">点击下载验收表</div>



            </van-cell-group>


            <div class="savebtn">
                <van-button
                        color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                        style="width: 3rem"
                        size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." @click="submit">保存</van-button>
            </div>
        </van-form>


    </div>
</template>
<style scoped>
    .box {
        /*margin-bottom: 1.5rem;*/
    }



    .savebtn {
        position: fixed;
        bottom: 0;
        padding-bottom: 0.2rem;
        width: 100%;
        z-index: 10;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-around;
        background: linear-gradient(180deg,hsla(0,0%,100%,0),#fff);
    }


    .van-tag {
        width: 55px;
        margin-left: 10px;
        text-align: center;
    }
    .between {
        justify-content: space-between;
    }


</style>
<script>
    import Vue from 'vue';
    import area from "../../../utils/area";
    import validator from "../../../utils/validator";
    import PicUploader from '@/components/picker/PicUploader.vue';
    import FileUploader from '@/components/picker/FileUploader.vue';

    import {Cell,Field,Area,Form,Divider, CellGroup,RadioGroup,Radio,Icon, Toast, Popup, Picker, Sidebar, SidebarItem, Tag, Stepper ,Switch ,Button} from 'vant';

    Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
        .use(Switch).use(Button);
    export default {
        name: 'ClubApply',
        components: {
            PicUploader,FileUploader
        },
        data: function () {
            return {
                validator,
                saveLoading:false,
                showArea:false,
                areaList:{},
                areaValue:'',
                submitType:'',
                formData: {
                    id: 0,
                    yanshoubiao_pic: [],
                    yanshou_pic: [],
                },
            }
        },
        filters: {},
        mounted() {
            document.title='提交材料'
            let that = this;
            that.areaList = area;
            that.formData.id = this.$route.query.id;
//            if(that.formData.id){
            this.fetch();
//            }
        },
        watch: {
            formData() {
            }
        },
        destroyed() {
        },
        methods: {
            onQuestion(){
                console.log('onQuestion')
            },
            onAreaConfirm(values) {
                console.log(values);
                this.formData.area = values[2].code;
                this.formData.province = values[0].name;
                this.formData.city = values[1].name;
                this.formData.county = values[2].name;
                this.showArea = false;
            },
            onSubmit(values){
                console.log('onSubmit-values',values);
                console.log('submitType',this.submitType);

                let that = this;
                console.log(that.formData)
                that.formValidate = true;

                for (let field in that.formData) {
                    if (that.formData.yanshou_pic.length == 0) {
                        Toast('请上传验收证明图片');
                        return
                    }
                    if (that.formData.yanshoubiao_pic.length == 0) {
                        Toast('请上传验收表扫描件');
                        return
                    }
                }
                that.saveLoading = true;

                that.$api.post('/api/club/yanshouSave', that.formData, (res) => {
                    that.saveLoading = false;
                    rbLink({
                        name:"ClubJiansheList",
                        query:{
                            id:res.data.id
                        }
                    },'back')
                }, (res) => {
                    Toast.fail(res.msg);
                    that.saveLoading = false;
                })
            },
            save(values){
                this.submitType = 'save';
            },
            onFailed(errorInfo){
                console.log('failed', errorInfo);
            },
            submit(values) {
                this.submitType = 'submit';
            },
            fetch(){
                let that = this;
                that.$api.post('/api/club/clubDetail', {
                }, (res) => {
                    that.formData = res.data;
                }, (res) => {
//                    Toast.fail(res.msg);
                })
            },
            download(){
                console.log('donwload')
                appEvent({
                    name: 'downloadFile',
                    query: {
                        name:'全国啦啦操星级俱乐部建设与验收表.pdf',
                        url:'http://www.ccachina.net/global_attachment_download_id_109356',
                    }
                });
            },

        }
    }
</script>



// WEBPACK FOOTER //
// ClubApplyYanshou.vue?3c2ea109